<template>
  <div class="group-subsection">
    <div class="overlap">
      <div class="view">
        <div class="overlap-2" :class="index==0?'selectedgroup':''" @mouseover="indexmouseover(0)" @mouseleave="resetIndex">
			<img v-if="index==0"
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/path.png"
			/>
			<img v-else
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/path1.png"
			/>
			
          <div class="text-wrapper-2">知识产权法</div>
          <!-- <div class="div">查看更多</div> -->
          <!-- <VuesaxLinearPath class="vuesax-linear-path" /> -->
          <!-- <img class="vector" alt="Vector" src="/img/vector-2-1.svg" /> -->
        </div>
      </div>
      <div class="group" >
        <div class="overlap-2" :class="index==1?'selectedgroup':''" @mouseover="indexmouseover(1)" @mouseleave="resetIndex">
			<img v-if="index==1"
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/receipt-item1.png"
			/>
			
			<img v-else
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/receipt-item.png"
			/>
          <div class="text-wrapper-2">商事合同</div>
          <!-- <div class="text-wrapper-3">查看更多</div> -->
        </div>
      </div>
      <div class="overlap-wrapper">
        <div class="overlap-2" :class="index==2?'selectedgroup':''" @mouseover="indexmouseover(2)" @mouseleave="resetIndex">
			<img v-if="index==2"
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/buildings11.png"
			/>
			<img v-else
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/buildingse.png"
			/>
          <div class="text-wrapper-2">房地产与建工程</div>
          <!-- <div class="text-wrapper-3">查看更多</div> -->
          
        </div>
      </div>
      <div class="overlap-group-wrapper" >
        <div class="overlap-2" :class="index==3?'selectedgroup':''" @mouseover="indexmouseover(3)" @mouseleave="resetIndex">
			<!-- <VuesaxLinearBrifecaseTick class="vuesax-linear" /> -->
			<img v-if="index==3"
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/brifecase-tick1.png"
			/>
			<img v-else
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/brifecase-tick.png"
			/>
          <div class="text-wrapper-2">破产清算与重组</div>
          <!-- <div class="text-wrapper-3">查看更多</div> -->
          
        </div>
      </div>
      <div class="div-wrapper" >
        <div class="overlap-2" :class="index==4?'selectedgroup':''"  @mouseover="indexmouseover(4)" @mouseleave="resetIndex">
			<img
			v-if="index==4"
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/buildings.png"
			/>
			<img
			v-else
			  class="vuesax-linear"
			  alt="Vuesax linear"
			  src="/img/buildings1.png"
			/>
          <div class="text-wrapper-2">投融资法律服务</div>
          <!-- <div class="text-wrapper-3">查看更多</div> -->
        </div>
      </div>
      
    </div>
	<div style="display: flex;flex-direction: column;margin-left: 30px;">
		<div class="text-wrapper-8" style="margin-bottom: 40px;color: #333333;">
		  优质的
		  <br />
		  法律综合服务能力
		</div>
		<div class="group-2">
		  <div class="text-wrapper-4" style="margin-bottom: 8px;">提供法律服务</div>
		  
		  <div class="text-wrapper-6" style="margin-bottom: 30px;">
		    <span class="counter">{{ displayCount1 }}</span>+
		  </div>
		  <div class="text-wrapper-5" style="margin-bottom: 8px;">服务企业</div>
		  <div class="text-wrapper-7">
		    <span class="counter">{{ displayCount2 }}</span>+
		  </div>
		</div>
	</div>
    
  </div>
</template>

<script>
import VuesaxLinearBrifecaseTick from "../../../icons/VuesaxLinearBrifecaseTick.vue";
import VuesaxLinearPath from "../../../icons/VuesaxLinearPath.vue";

export default {
  name: "ServiceSection",
  components: {
    VuesaxLinearBrifecaseTick,
    VuesaxLinearPath
  },
  data() {
    return {
	  index: -1,
      displayCount1: 0,
      displayCount2: 0,
      targetCount1: 15000,
      targetCount2: 100,
      animationStarted: false
    };
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
	   resetIndex() {
	        this.index = -1; // 鼠标移出时重置 index
	      },
	  indexmouseover(e){
		  this.index = e
	  },
    startAnimation() {
      if (this.animationStarted) return;
      this.animationStarted = true;
      
      // 监听滚动事件，当元素进入视口时开始动画
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateCounters();
            observer.unobserve(entry.target);
          }
        });
      });
      
      observer.observe(this.$el);
    },
    
    animateCounters() {
      const duration = 2000; // 动画持续时间2秒
      const steps = 60; // 动画步数
      const stepDuration = duration / steps;
      
      let step = 0;
      const timer = setInterval(() => {
        step++;
        
        // 使用缓动函数让动画更自然
        const progress = this.easeOutQuart(step / steps);
        
        this.displayCount1 = Math.floor(this.targetCount1 * progress);
        this.displayCount2 = Math.floor(this.targetCount2 * progress);
        
        if (step >= steps) {
          this.displayCount1 = this.targetCount1;
          this.displayCount2 = this.targetCount2;
          clearInterval(timer);
        }
      }, stepDuration);
    },
    
    // 缓动函数，让动画更自然
    easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 4);
    }
  }
};
</script>

<style scoped>
.group-subsection {
  height: 260px;
  /* left: 424px; */
  /* */
  /* top: 200px; */
  width: 1098px;
  display: flex;
  z-index: 9999;
}

.group-subsection .overlap {
  height: 260px;
  /* left: 0; */
  /* */
  /* top: 0; */
  width: 904px;
  display: flex;
}

.group-subsection .view {
  height: 260px;
  /* left: 0; */
  /* */
  /* top: 0; */
  width: 184px;
}

.group-subsection .overlap-group {
  background-color: #fff;
  height: 260px;
  width: 180px;
} 

.selectedgroup {
  background-color: var(--yxd-41k) !important;
  background-image: url(/img/mask-group-7.png);
  background-size: 100% 100%;
  height: 260px;
  position: relative;
  width: 180px;
  color: #fff;
} 

.group-subsection .text-wrapper {
  /* color: var(--q-pd-79g); */
  font-family: "PingFang SC-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
  /* left: 20px; */
  letter-spacing: 0;
  line-height: 24px;
  /* */
  /* top: 106px; */
  white-space: nowrap;
}

.group-subsection .div {
  color: var(--q-pd-79g);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 12px;
  font-weight: 500;
  /* left: 24px; */
  letter-spacing: 0;
  line-height: 20px;
  /* */
  /* top: 204px; */
  white-space: nowrap;
}

.group-subsection .vuesax-linear-path {
  /* height: 32px !important;
  left: 20px !important;
  position: absolute !important;
  top: 57px !important;
  width: 32px !important; */
}

.group-subsection .vector {
  height: 7px;
  left: 80px;
  object-fit: cover;
  /* */
  /* top: 210px; */
  width: 13px;
}

.group-subsection .group {
  height: 260px;
  /* left: 180px; */
  /* */
  /* top: 0; */
  width: 184px;
}

.group-subsection .overlap-2 {
  background-color: #ffffff;
  background-image: url(/img/mask-group-11.png);
  background-size: 100% 100%;
  height: 260px;
  /* position: relative; */
  width: 180px;
   padding-top: 29px;
  
}

.group-subsection .text-wrapper-2 {
  /* color: var(--x-1); */
  font-family: "PingFang SC-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
  /* left: 24px; */
  letter-spacing: 0;
  line-height: 24px;
  /* */
  /* top: 106px; */
  white-space: nowrap;
  margin-left: 30px;
}

.group-subsection .text-wrapper-3 {
  /* color: var(--x-1); */
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 12px;
  font-weight: 500;
  /* left: 28px; */
  letter-spacing: 0;
  line-height: 20px;
  /* */
  /* top: 204px; */
  white-space: nowrap;
}

.group-subsection .vuesax-linear {
  height: 32px;
  left: 24px;
  /* */
  top: 57px;
  width: 32px;
  margin-top: 60px;
  margin-left: 30px;
  margin-bottom: 10px;
}

.group-subsection .overlap-wrapper {
  height: 260px;
  left: 360px;
  /* */
  top: 0;
  width: 184px;
}

.group-subsection .overlap-group-wrapper {
  height: 260px;
  left: 540px;
  /* */
  top: 0;
  width: 184px;
}

.group-subsection .div-wrapper {
  height: 260px;
  left: 720px;
  /* */
  top: 0;
  width: 184px;
}

.group-subsection .img {
  height: 32px;
  left: 747px;
  /* */
  top: 57px;
  width: 32px;
}

.group-subsection .group-2 {
  height: 168px;
  left: 936px;
  /* */
  top: 92px;
  width: 113px;
}

.group-subsection .text-wrapper-4 {
  color: var(--x-1);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 12px;
  font-weight: 500;
  left: 0;
  letter-spacing: 0;
  line-height: 20px;
  /* */
  top: 0;
  white-space: nowrap;
}

.group-subsection .text-wrapper-5 {
  color: var(--x-1);
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 12px;
  font-weight: 500;
  left: 0;
  letter-spacing: 0;
  line-height: 20px;
  /* */
  top: 100px;
  white-space: nowrap;
}

.group-subsection .text-wrapper-6 {
  color: var(--yxd-41k);
  font-family: "DIN-Bold", Helvetica;
  font-size: 32px;
  font-weight: 700;
  left: 0;
  letter-spacing: 0;
  line-height: 40px;
  /* */
  top: 28px;
  white-space: nowrap;
}

.group-subsection .text-wrapper-7 {
  color: var(--yxd-41k);
  font-family: "DIN-Bold", Helvetica;
  font-size: 32px;
  font-weight: 700;
  left: 0;
  letter-spacing: 0;
  line-height: 40px;
 
  top: 128px;
  white-space: nowrap;
}

.group-subsection .text-wrapper-8 {
  /* color: var(--x-1); */
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 20px;
  font-weight: 500;
  left: 936px;
  letter-spacing: 0;
  line-height: 28px;
 
  top: 0;
}

.group-subsection .counter {
  display: inline-block;
  transition: all 0.1s ease;
  animation: numberFlip 0.1s ease-out;
}

@keyframes numberFlip {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>